import { LogInEvent } from '../../event'

export function handleLogIn(_event: LogInEvent) {
  window.dataLayer.push({
    event: 'login',
  })
}
